import AudioNew from 'client/components/entities/Audio/AudioNew'
import { BookingCalendar } from 'client/components/entities/BookingCalendar'
import Button from 'client/components/entities/Button'
import BlogPageBody from 'client/components/entities/blog-page-body'
import { BlogPostBody } from 'client/components/entities/blog-post-body'
import BlogPostLayoutBody from 'client/components/entities/blog-post-layout-body'
import { Body } from 'client/components/entities/body'
import ButtonNew from 'client/components/entities/button-new'
import Column from 'client/components/entities/Column'
import ContentBox from 'client/components/entities/ContentBox'
import Countdown from 'client/components/entities/Countdown'
import Field from 'client/components/entities/field-new'
import Headline from 'client/components/entities/Headline'
import ImageNew from 'client/components/entities/Image/Image'
import InlineBody from 'client/components/entities/inline-body'
import Menu from 'client/components/entities/Menu/Menu'
import NewBulletList from 'client/components/entities/NewBulletList'
import NewHorizontalLine from 'client/components/entities/NewHorizontalLine'
import OfferThankYouOrderSummaryNew from 'client/components/entities/OfferThankYouOrderSummaryNew'
import PaymentButtonNew from 'client/components/entities/PaymentButton/PaymentButtonNew'
import PopupNew from 'client/components/entities/popup-new'
import { PriceElement } from 'client/components/entities/price-element'
import Recaptcha from 'client/components/entities/Recaptcha'
import Row from 'client/components/entities/Row'
import ReadOnlyRow from 'client/components/entities/Row/components/ReadOnlyRow'
import RemotePopupBody from 'client/components/entities/remote-popup-body'
import Section from 'client/components/entities/Section'
import ShippingFees from 'client/components/entities/ShippingFees'
import StartTimer from 'client/components/entities/StartTimer'
import TextNew from 'client/components/entities/Text/Text'
import TwitterTweetButton from 'client/components/entities/TwitterTweetButton'
import { OfferPrice } from 'client/pages/offer/entities/offer-price'
import Product from 'client/pages/offer/entities/Product'
import { ColumnInterface } from 'common/components/entities/Column/types/ColumnInterface'
import MenuInterface from 'common/components/entities/Menu/types/MenuInterface'
import { RowInterface } from 'common/components/entities/Row/types/RowInterface'
import { SectionInterface } from 'common/components/entities/Section/types/SectionInterface'
import structureTypes from 'common/constants/structureTypes'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { AudioInterface } from 'common/types/entities/AudioInterface'
import { BlogContentPlaceholderInterface } from 'common/types/entities/BlogContentPlaceholderInterface'
import { BlogPageBodyInterface } from 'common/types/entities/blog-page-body-interface'
import { BlogPostLayoutInterface } from 'common/types/entities/blog-post-layout-body-interface'
import { BodyInterface } from 'common/types/entities/body-interface'
import { ContentBoxInterface } from 'common/types/entities/ContentBoxInterface'
import { ContentTableInterface } from 'common/types/entities/ContentTableInterface'
import { CountdownInterface } from 'common/types/entities/CountdownInterface'
import { CustomerTypeInterface } from 'common/types/entities/CustomerTypeInteface'
import { CustomLoginForgotPasswordInterface } from 'common/types/entities/CustomLoginForgotPasswordInterface'
import EntityInterface from 'common/types/entities/EntityInterface'
import { HeadlineInterface } from 'common/types/entities/HeadlineInterface'
import { HorizontalLineInterface } from 'common/types/entities/HorizontalLineInterface'
import { ImageInterface } from 'common/types/entities/ImageInterface'
import { OfferPriceInterface } from 'common/types/entities/OfferPriceInterface'
import { OldEntityInterface } from 'common/types/entities/OldEntityInterface'
import { PaymentMethodInterface } from 'common/types/entities/PaymentMethodInterface'
import ProductEntityInterface from 'common/types/entities/ProductInterface'
import { PopupInterface } from 'common/types/entities/popup-interface'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import { ShippingFeesInterface } from 'common/types/entities/ShippingFeesInterface'
import { SurveyInterface } from 'common/types/entities/SurveyInterface'
import { TextInterface } from 'common/types/entities/TextInterface'
import { TwitterTweetButtonInterface } from 'common/types/entities/TwitterTweetButtonInterface'
import { VideoInterface } from 'common/types/entities/VideoInterface'
import React from 'react'
import { Agreement } from 'src/editor/shared/entities/agreement'
import { Carousel } from 'src/editor/shared/entities/carousel'
import Checkbox from 'src/editor/shared/entities/checkbox'
import { Coupon } from 'src/editor/shared/entities/coupon'
import { Faq } from 'src/editor/shared/entities/faq'
import { FieldNew } from 'src/editor/shared/entities/field-new'
import { Form } from 'src/editor/shared/entities/form'
import { LoginButton } from 'src/editor/shared/entities/login-button'
import { RegistrationButton } from 'src/editor/shared/entities/registration-button'
import { Search } from 'src/editor/shared/entities/search'
import { SearchResults } from 'src/editor/shared/entities/search-results'
import { WebsiteButton } from 'src/editor/shared/entities/website-button'
import { WebsiteLanguageSwitcher } from 'src/editor/shared/entities/website-language-switcher'
import { WebsiteLayoutBody } from 'src/editor/shared/entities/website-layout-body'
import { WebsitePageBody } from 'src/editor/shared/entities/website-page-body'
import { AgreementInterface } from 'src/shared/entities/agreement/agreement.schema'
import { ButtonEntityInterface } from 'src/shared/entities/button/button.schema'
import { CarouselInterface } from 'src/shared/entities/carousel/carousel.schema'
import { CheckboxEntityInterface } from 'src/shared/entities/checkbox/checkbox-entity.schema'
import { CouponInterface } from 'src/shared/entities/coupon/coupon.schema'
import { FaqInterface } from 'src/shared/entities/faq/faq.schema'
import { FieldEntityInterface } from 'src/shared/entities/field/field-entity.schema'
import { FormInterface } from 'src/shared/entities/form/form.schema'
import { LoginButtonEntityInterface } from 'src/shared/entities/login-button/login-button-entity.schema'
import { PaymentButtonEntityInterface } from 'src/shared/entities/payment-button/payment-button.schema'
import { RegistrationButtonEntityInterface } from 'src/shared/entities/registration-button/registration-button-entity.schema'
import { WebsiteButtonEntityInterface } from 'src/shared/entities/website-button/website-button.schema'
import { WebsiteLanguageSwitcherInterface } from 'src/shared/types/entities/website-language-switcher-interface'
import {
  WebsiteLayoutBodyInterface,
  WebsitePageInterface,
} from 'src/shared/types/website-entities'
import { LanguageSwitcherInterface } from '../../common/types/entities/LanguageSwitcherInterface'
import { RawHtmlInterface } from '../../common/types/entities/RawHtmlInterface'
import ContentTable from '../components/entities/ContentTable'
import NewLanguageSwitcher from '../components/entities/LanguageSwitcher/NewLanguageSwitcher'
import NewRawHtml from '../components/entities/RawHtml/NewRawHtml'
import SurveyNew from '../components/entities/Survey/Survey'
import VideoNew from '../components/entities/VideoNew'
import { BlogContentPlaceholder } from './blog/entities/BlogContentPlaceholder'
import { ForgotPassword } from './custom-login/entities/ForgotPassword'
import CustomerTypeNew from './offer/entities/CustomerType'
import OrderBump from './offer/entities/order-bump'
import PaymentMethod from './offer/entities/PaymentMethod'

export type AdditionalProps = {
  isMoveDownAllowed: boolean
  isMoveUpAllowed: boolean
}

export const createEmptyEntityElement = () => {
  return <div />
}

export default function createCommonEntityElement(
  entity: EntityInterface | OldEntityInterface,
  additionalProps: AdditionalProps,
) {
  const { type, id } = entity

  switch (type) {
    case EntityTypeEnum.Body: {
      return (
        <Body
          entity={entity as BodyInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.BlogPostBody:
    case EntityTypeEnum.WebsiteBlogPostBody: {
      return (
        <BlogPostBody
          entity={entity as BodyInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.BlogPageBody:
    case EntityTypeEnum.WebsiteBlogPageBody: {
      return (
        <BlogPageBody
          entity={entity as BlogPageBodyInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.BlogPostLayoutBody:
    case EntityTypeEnum.WebsiteBlogPostLayoutBody: {
      return (
        <BlogPostLayoutBody
          entity={entity as BlogPostLayoutInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.Section:
      return (
        <Section
          entity={entity as SectionInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Row: {
      if (entity.isReadOnly) {
        return (
          <ReadOnlyRow entity={entity as RowInterface} key={`entity-${id}`} />
        )
      }
      return (
        <Row
          entity={entity as RowInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.Column:
      return (
        //@ts-expect-error @TODO harmonize interfaces
        <Column
          entity={entity as ColumnInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Headline:
      return (
        <Headline
          entity={entity as HeadlineInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BulletList:
      return (
        <NewBulletList
          //@ts-expect-error @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BookingCalendar:
      return (
        <BookingCalendar
          //@ts-expect-error @TODO harmonize interfaces
          entity={entity}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Image:
      return (
        <ImageNew
          entity={entity as ImageInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Button:
      return (
        <ButtonNew
          entity={entity as ButtonEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.WebsiteButton:
      return (
        <WebsiteButton
          entity={entity as WebsiteButtonEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.LoginButton:
      return (
        <LoginButton
          entity={entity as LoginButtonEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.RegistrationButton:
      return (
        <RegistrationButton
          entity={entity as RegistrationButtonEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.BUTTON:
      return (
        <Button
          //@ts-expect-error @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.FORM_INPUT:
      return (
        <Field
          //@ts-expect-error @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Field:
      return (
        <FieldNew
          entity={entity as FieldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Form:
      return (
        <Form
          entity={entity as FormInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Popup:
      return (
        <PopupNew
          entity={entity as PopupInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.RemotePopupBody:
      return (
        <RemotePopupBody
          //@ts-expect-error @TODO harmonize interfaces
          entity={entity}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.InlineBody:
      return (
        //@ts-expect-error @TODO harmonize interfaces
        <InlineBody entity={entity} key={`entity-${id}`} {...additionalProps} />
      )
    case EntityTypeEnum.Video:
      return (
        <VideoNew
          entity={entity as VideoInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.OfferPrice:
      return (
        <OfferPrice
          entity={entity as OfferPriceInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Product:
      return (
        <Product
          entity={entity as ProductEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.RawHtml:
      return (
        <NewRawHtml
          entity={entity as RawHtmlInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.OrderBump:
      return (
        //@ts-expect-error @TODO harmonize interfaces
        <OrderBump entity={entity} {...additionalProps} key={`entity-${id}`} />
      )
    case EntityTypeEnum.Checkbox:
      return (
        <Checkbox
          entity={entity as CheckboxEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case structureTypes.START_TIMER:
      return (
        <StartTimer
          //@ts-expect-error @TODO harmonize interfaces
          entity={entity as OldEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.OrderSummary:
      return (
        <OfferThankYouOrderSummaryNew
          entity={entity as EntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Coupon:
      return (
        <Coupon
          key={`entity-${id}`}
          entity={entity as CouponInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.BlogContentPlaceholder:
      return (
        <BlogContentPlaceholder
          entity={entity as BlogContentPlaceholderInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Menu:
      return (
        <Menu
          entity={entity as MenuInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.LanguageSwitcher:
      return (
        <NewLanguageSwitcher
          entity={entity as LanguageSwitcherInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.WebsiteLanguageSwitcher:
      return (
        <WebsiteLanguageSwitcher
          entity={entity as WebsiteLanguageSwitcherInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.TwitterTweetButton:
      return (
        <TwitterTweetButton
          entity={entity as TwitterTweetButtonInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Carousel:
      return (
        <Carousel
          entity={entity as CarouselInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Faq:
      return (
        <Faq
          entity={entity as FaqInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.PriceElement:
      return (
        <PriceElement
          //@ts-expect-error @TODO harmonize interfaces
          entity={entity}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.SearchResults:
      return (
        <SearchResults
          //@ts-expect-error @TODO harmonize interfaces
          entity={entity}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Search:
      return (
        //@ts-expect-error @TODO harmonize interfaces
        <Search entity={entity} key={`entity-${id}`} {...additionalProps} />
      )
    case EntityTypeEnum.Text:
      return (
        <TextNew
          entity={entity as TextInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.ContentTable:
      return (
        <ContentTable
          entity={entity as ContentTableInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Survey:
      return (
        <SurveyNew entity={entity as SurveyInterface} {...additionalProps} />
      )
    case EntityTypeEnum.HorizontalLine:
      return (
        <NewHorizontalLine
          entity={entity as HorizontalLineInterface}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Audio:
      return (
        <AudioNew
          entity={entity as AudioInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.OptInRecaptcha: {
      return (
        <Recaptcha entity={entity as RecaptchaInterface} {...additionalProps} />
      )
    }
    case EntityTypeEnum.Countdown: {
      return (
        <Countdown entity={entity as CountdownInterface} {...additionalProps} />
      )
    }
    case EntityTypeEnum.CustomLoginForgotPassword: {
      return (
        <ForgotPassword
          entity={entity as CustomLoginForgotPasswordInterface}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.CustomerType: {
      return (
        <CustomerTypeNew
          entity={entity as CustomerTypeInterface}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.ContentBox: {
      return (
        <ContentBox
          entity={entity as ContentBoxInterface}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.PaymentMethod: {
      return (
        <PaymentMethod
          entity={entity as PaymentMethodInterface}
          {...additionalProps}
        />
      )
    }
    case EntityTypeEnum.Comments:
      return <div />
    case EntityTypeEnum.ShippingFees:
      return (
        <ShippingFees
          entity={entity as ShippingFeesInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.PaymentButton:
      return (
        //@ts-expect-error @TODO harmonize interfaces
        <PaymentButtonNew
          entity={entity as PaymentButtonEntityInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.Agreement:
      return (
        <Agreement
          entity={entity as AgreementInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.WebsiteLayoutBody:
      return (
        <WebsiteLayoutBody
          entity={entity as WebsiteLayoutBodyInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    case EntityTypeEnum.WebsitePageBody:
      return (
        <WebsitePageBody
          entity={entity as WebsitePageInterface}
          key={`entity-${id}`}
          {...additionalProps}
        />
      )
    default: {
      if (process.env.NODE_ENV === 'development') {
        // biome-ignore lint/suspicious/noConsole: exception for development environment
        console.warn(`unknown type ${type} of entity id = ${id}`)
        return (
          <div>
            <i className="fas fa-bug" />
            <span> !!! INVALID ENTITY !!!</span>
          </div>
        )
      }

      return <div className="test" />
    }
  }
}
